/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Talk_Feature_1Inputs */

const en_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call recordings`)
};

const id_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perekaman panggilan`)
};

const ms_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rakaman panggilan`)
};

const ca_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gravacions de trucades`)
};

const cs_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Záznamy hovorů`)
};

const da_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optagelser af opkald`)
};

const de_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anruf-Aufnahmen`)
};

const et_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kõnesalvestused`)
};

const es_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grabación de llamadas`)
};

const fr_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrements des appels`)
};

const hr_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snimanje poziva`)
};

const it_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrazione delle chiamate`)
};

const lv_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zvanu ieraksti`)
};

const lt_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skambučių įrašai`)
};

const hu_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hívások rögzítése`)
};

const nl_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesprekken opnemen`)
};

const nb_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samtaleopptak`)
};

const pl_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagrywanie rozmów`)
};

const pt_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gravações de chamada`)
};

const ro_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Înregistrarea apelurilor`)
};

const sk_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrávanie hovorov`)
};

const sl_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posnetki klicev`)
};

const fi_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puhelutallenteet`)
};

const sv_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspelning av samtal`)
};

const vi_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi âm cuộc gọi`)
};

const tr_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görüşme kayıtları`)
};

const el_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Καταγραφές κλήσεων`)
};

const bg_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записи на разговорите`)
};

const ru_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записи звонков`)
};

const sr_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Снимање позива`)
};

const uk_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записи дзвінків`)
};

const ka_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ზარების ჩანაწერი`)
};

const hi_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कॉल रिकॉर्डिंग्स `)
};

const th_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การบันทึกการโทร`)
};

const ko_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`통화 녹음`)
};

const zh_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`录制通话`)
};

const zh_tw_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通話錄音`)
};

const ja_talk_feature_1 = /** @type {(inputs: Talk_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通話録音`)
};

/**
* | output |
* | --- |
* | "Call recordings" |
*
* @param {Talk_Feature_1Inputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const talk_feature_1 = /** @type {((inputs?: Talk_Feature_1Inputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Talk_Feature_1Inputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_talk_feature_1(inputs)
	if (locale === "ms") return ms_talk_feature_1(inputs)
	if (locale === "ca") return ca_talk_feature_1(inputs)
	if (locale === "cs") return cs_talk_feature_1(inputs)
	if (locale === "da") return da_talk_feature_1(inputs)
	if (locale === "de") return de_talk_feature_1(inputs)
	if (locale === "et") return et_talk_feature_1(inputs)
	if (locale === "es") return es_talk_feature_1(inputs)
	if (locale === "fr") return fr_talk_feature_1(inputs)
	if (locale === "hr") return hr_talk_feature_1(inputs)
	if (locale === "it") return it_talk_feature_1(inputs)
	if (locale === "lv") return lv_talk_feature_1(inputs)
	if (locale === "lt") return lt_talk_feature_1(inputs)
	if (locale === "hu") return hu_talk_feature_1(inputs)
	if (locale === "nl") return nl_talk_feature_1(inputs)
	if (locale === "nb") return nb_talk_feature_1(inputs)
	if (locale === "pl") return pl_talk_feature_1(inputs)
	if (locale === "pt") return pt_talk_feature_1(inputs)
	if (locale === "ro") return ro_talk_feature_1(inputs)
	if (locale === "sk") return sk_talk_feature_1(inputs)
	if (locale === "sl") return sl_talk_feature_1(inputs)
	if (locale === "fi") return fi_talk_feature_1(inputs)
	if (locale === "sv") return sv_talk_feature_1(inputs)
	if (locale === "vi") return vi_talk_feature_1(inputs)
	if (locale === "tr") return tr_talk_feature_1(inputs)
	if (locale === "el") return el_talk_feature_1(inputs)
	if (locale === "bg") return bg_talk_feature_1(inputs)
	if (locale === "ru") return ru_talk_feature_1(inputs)
	if (locale === "sr") return sr_talk_feature_1(inputs)
	if (locale === "uk") return uk_talk_feature_1(inputs)
	if (locale === "ka") return ka_talk_feature_1(inputs)
	if (locale === "hi") return hi_talk_feature_1(inputs)
	if (locale === "th") return th_talk_feature_1(inputs)
	if (locale === "ko") return ko_talk_feature_1(inputs)
	if (locale === "zh") return zh_talk_feature_1(inputs)
	if (locale === "zh-tw") return zh_tw_talk_feature_1(inputs)
	if (locale === "ja") return ja_talk_feature_1(inputs)
	return en_talk_feature_1(inputs)
});